//core
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { numberToLocaleFormat, strToNumberFormat } from "../../../../../helpers/utils";
import {Box, Typography} from "@mui/material";
import { getSymbolFromCode } from "currency-code-symbol-map";
import { useTranslation } from "react-i18next";

//styles
import { useStyles } from "./styles";
import FloatFormat from "../FloatFormat";

interface IValue {
  value: string | number;
  currency: any;
  color?: string;
}

const FloatCurrency = ({
  value,
  color = '',
  currency,
}: IValue) => {
  const styles = useStyles();
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState<string>('en');
  const renderValue = (!!value) && (value !== '∞') ? numberToLocaleFormat(value, locale) : value;
  const textColor = ((renderValue !== '0.00') && (renderValue !== '0,00') && (renderValue !== '0') && (renderValue !== 0))
    ? !!color
      ? color
      : 'inherit'
    : 'inherit';

  useEffect(() => {
    if (i18n.language === 'ru') {
      setLocale('ru');
    }
    if (i18n.language === 'en') {
      setLocale('en');
    }
    if (i18n.language === 'uk') {
      setLocale('uk');
    }
    if (i18n.language === 'es') {
      setLocale('es');
    }
    if (i18n.language === 'tr') {
      setLocale('tr');
    }
    if (i18n.language === 'ko') {
      setLocale('ko');
    }
    if (i18n.language === 'el') {
      setLocale('el');
    }
    if (i18n.language === 'fr') {
      setLocale('fr');
    }
    if (i18n.language === 'pt') {
      setLocale('pt');
    }
  }, [i18n.language]);

  return (
    <>
      <Typography className={`${styles.ltr} force-ltr`} component={'div'} variant={'body2'} sx={{ color: textColor }}>
        {getSymbolFromCode(currency) ? (<Box>{getSymbolFromCode(currency)} </Box>) : `${currency} `}
        <Box>
          {value === null ? '—' : <FloatFormat value={renderValue} />}
        </Box>
      </Typography>
    </>
  );
};

export default FloatCurrency;
